import type { PaletteOptions } from '@mui/material/styles'
import { common } from '@mui/material/colors'
import { alpha } from '@mui/material/styles'
import {
  error,
  info,
  nabuColors,
  neutral,
  success,
  warning,
  standard,
} from '../colors'
import type { Contrast } from '../index'
import { getPrimary } from '../utils'

interface Config {
  contrast?: Contrast
}

/** Fond des zones « page » (layout, canvas) en mode clair — cartes / paper restent blanches. */
const BACKGROUND_DEFAULT_LIGHT = '#F7F9FB'

export const createPalette = (
  config: Config
): PaletteOptions & { standard: any } => {
  const { contrast } = config

  return {
    action: {
      active: neutral[500],
      disabled: alpha(neutral[900], 0.38),
      disabledBackground: alpha(neutral[900], 0.12),
      focus: alpha(neutral[900], 0.16),
      hover: alpha(neutral[900], 0.04),
      selected: alpha(neutral[900], 0.12),
    },
    background: {
      default: BACKGROUND_DEFAULT_LIGHT,
      paper: common.white,
    },
    // Plus marqué que l’ancien #F2F4F7 pour bordures / séparateurs sur fond blanc
    divider: contrast === 'high' ? neutral[300] : neutral[200],
    error,
    info,
    mode: 'light',
    neutral,
    nabuColors,
    secondary: {
      main: neutral[500],
    },
    primary: getPrimary(),
    success,
    text: {
      primary: neutral[900],
      secondary: neutral[500],
      disabled: alpha(neutral[900], 0.38),
    },
    warning,
    standard,
  }
}
